const SvgPasswordVisible = () => (
	<svg width="1em" height="1em" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11.244 1C5.8 1 2.775 5.234 1.7 7.116c-.221.387-.331.58-.32.868.013.288.143.476.402.852C3.062 10.693 6.538 15 11.244 15c4.706 0 8.182-4.306 9.462-6.164.26-.376.39-.564.401-.852.013-.288-.098-.481-.318-.868C19.713 5.234 16.689 1 11.244 1Z"
			stroke="#827D85"
			strokeWidth={1.5}
		/>
		<circle cx={11.244} cy={8} r={3} stroke="#827D85" strokeWidth={1.5} />
	</svg>
)

export default SvgPasswordVisible
